import { createClass as _createClass, classCallCheck as _classCallCheck } from '../../../_virtual/_rollupPluginBabelHelpers.js';

/* eslint-disable unicorn/filename-case */

/**
 * candidateSelectors, candidateSelector and isHidden are inspired from David Clark's fantastic Tabbable repo
 * https://github.com/davidtheclark/tabbable
 * */

/**
 * these selectors represent most focusable elements (remaining exceptions are accounted for with isHidden())
 */
var candidateSelectors = ['[contenteditable]:not([contenteditable="false"])', '[tabindex]', 'a[href]', 'audio[controls]', 'button:not([disabled])', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'video[controls]'];
/**
 * <button>, <input>, <select>, and <textarea> with ":not([disabled])" are not tabbable, but are focusable.
 * The following array includes both focusable AND tabbable elements
 */

var tabbableCandidateSelectors = [].concat(candidateSelectors, ['button', 'input', 'select', 'textarea']);
var candidateSelector = candidateSelectors.join(',');
var tabbableCandidateSelector = tabbableCandidateSelectors.join(',');

function isHidden(el) {
  /**
   * Without this check a focusable el in a parent with "display: none" or "visibility: hidden" will
   * get treated like an eligible focusable item. An el with "visibility: hidden" will also be treated
   * like an eligible item, so this function checks for that as well. Interestingly, an el itself with
   * "display: none" is not treated as an eligible el, so we don't need to check for it.
   *
   * el.offsetParent will return null if the el's parent has "display: none" or "visibility: hidden"
   * getComputedStyled(el).visibility is to check if the el itself has "visibility: hidden"
   */
  return el.offsetParent === null || getComputedStyle(el).visibility === 'hidden';
}
/* eslint-disable unicorn/no-for-loop */


function getFirstFocusableChild(els) {
  for (var i = 0; i < els.length; i++) {
    if (!isHidden(els[i])) {
      return els[i];
    }
  }

  return null;
}

function getFirstFocusableEl(containerEl, hasShadowRoot) {
  var _a; // if the parentEl is focusable we'll apply focus to it


  if (containerEl.matches(candidateSelector) && !isHidden(containerEl)) return containerEl;

  if (hasShadowRoot) {
    var getShadowEls = (_a = containerEl === null || containerEl === void 0 ? void 0 : containerEl.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll(candidateSelector);
    return getShadowEls && getFirstFocusableChild(getShadowEls);
  } // otherwise return the first el that matches the candidateSelector


  var getEls = containerEl.querySelectorAll(candidateSelector); // now it's time to loop through each focusable el to find the first one that isn't hidden

  return getFirstFocusableChild(getEls);
}
function isTabbableEl(el) {
  return el.matches(tabbableCandidateSelector) && !isHidden(el);
}
var A11yHider = /*#__PURE__*/function () {
  function A11yHider() {
    _classCallCheck(this, A11yHider);
  }

  _createClass(A11yHider, null, [{
    key: "hide",
    value: function hide(el) {
      if (!el) return;
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('tabindex', '-1');
    }
  }, {
    key: "show",
    value: function show(el) {
      if (!el) return;
      el.removeAttribute('aria-hidden');
      el.removeAttribute('tabindex');
    }
  }]);

  return A11yHider;
}();

export { A11yHider, candidateSelector, getFirstFocusableEl, isTabbableEl, tabbableCandidateSelector };
